import axios, { AxiosResponse } from 'axios';

class ParentsRequest {
  private static getBaseUrl(): string {
    return import.meta.env.VITE_PARENTS_API_URL;
  }

  private static getHeaders(jwtToken?: string): any {
    let headers: any = {};

    if (jwtToken) {
      headers['Authorization'] = `Bearer ${jwtToken}`;
    }

    headers['x-api-key'] = import.meta.env.VITE_PARENTS_API_KEY;

    return headers;
  }

  static async post<T = any>(endpoint: string, data: any, jwtToken?: string): Promise<AxiosResponse<T>> {
    const url = this.getBaseUrl() + endpoint;
    const headers = this.getHeaders(jwtToken);
    return axios.post<T>(url, data, { headers });
  }

  static async get<T = any>(endpoint: string, jwtToken?: string): Promise<AxiosResponse<T>> {
    const url = this.getBaseUrl() + endpoint;
    const headers = this.getHeaders(jwtToken);
    return axios.get<T>(url, { headers });
  }
}

export default ParentsRequest;
